import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebcamImage } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { Dependent } from 'src/app/core/models/dependent';
import { DependentService } from 'src/app/core/services/general/dependent.service';
import { base64StringToBlob } from 'blob-util'
import { ToastService } from 'src/app/core/services/toast-service.service';

@Component({
  selector: 'app-take-member-photo',
  templateUrl: './take-member-photo.component.html',
  styleUrls: ['./take-member-photo.component.scss']
})

export class TakeMemberPhotoComponent {
  @Input() dependent!: Dependent;

  public trigger: Subject<void> = new Subject<void>();
  public webcamImage?: WebcamImage;
  public loading: boolean = false;

  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 400 },
    height: { ideal: 400 }
  };


  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private dependentService: DependentService
  ) {

  }


  convertWebcamImageToBlob() {
    const base64Data = this.webcamImage!.imageAsBase64;
    return base64StringToBlob(base64Data);
  }


  uploadMemberPhoto() {
    this.loading = true;
    const formData = new FormData();
    formData.append(
      'member_number',
      this.dependent.member_number
    );
    formData.append(
      'beneficiary_number',
      this.dependent.beneficiary_number
    );
    formData.append(
      'member_profile_image_file',
      this.convertWebcamImageToBlob()
    );
    this.dependentService.uploadMemberPhoto(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.toastService.showSuccess("Member photo has been updated successfully.");
        this.activeModal.close(new Dependent(res));
      }
    });
  }


  public triggerSnapshot(): void {
    this.trigger.next();
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      this.triggerSnapshot()
    }
  }

  public clearSnapshot(): void {
    this.webcamImage = undefined;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.convertWebcamImageToBlob();
  }


}
